import { render, staticRenderFns } from "./WaistbandImage.vue?vue&type=template&id=893b6d16&scoped=true&"
import script from "./WaistbandImage.vue?vue&type=script&lang=js&"
export * from "./WaistbandImage.vue?vue&type=script&lang=js&"
import style0 from "./WaistbandImage.vue?vue&type=style&index=0&id=893b6d16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893b6d16",
  null
  
)

export default component.exports